module.exports = __webpack_public_path__ + "images/wind-rose-86bedccb681a5654637dcafdc781c4be.jpg";